/**
 * @copyright 2024 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { ErrorComponent } from '@/components/ui'

const ErrorPage: React.FC = () => {
  return (
    <>
      <ErrorComponent />
    </>
  )
}

export default ErrorPage
